import { render, staticRenderFns } from "./contest-quiz-section-update.html?vue&type=template&id=32f5c48d&scoped=true&"
import script from "./contest-quiz-section-update.js?vue&type=script&lang=js&"
export * from "./contest-quiz-section-update.js?vue&type=script&lang=js&"
import style0 from "./contest-quiz-section-update.scss?vue&type=style&index=0&id=32f5c48d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5c48d",
  null
  
)

export default component.exports